import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import UsersService from "../../../../services/UserService";
import DeleteModal from "../../../common/DeleteModal";
import { usePermissions } from "../../../common/permissions";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const { canEdit, canDelete } = usePermissions();
	const usersService = new UsersService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.client_name || "-"}</td>
			<td>{item?.client_phone}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{/* <img
						src={eyeIcon}
						onClick={() => {}}
						className="cursor-pointer"
						alt="view"
						width={24}
					/> */}
					{canEdit("user") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("user") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.client_name}
					deletedItem={item}
					modelService={usersService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
